export const NOVEL_CANONICAL_STORY_TAGS = [
  'revenge',
  'infidelity',
  'love triangle',
  'pregnancy',
  'miscarriage',
  'parent-child',
  'werewolf',
  'rebirth',
  'toxic romance',
  'betrayal',
  'misunderstanding',
  'substitute lover',
  'terminal illness',
  'car accident',
  'paralysis',
  'argument',
  'sexual tension',
  'reverse harem',
  'contract marriage',
  'soul swap',
  'domestic abuse',
] as const

export const NOVEL_CANONICAL_IDENTITY_TAGS = [
  'lawyer',
  'novelist',
  'wealthy family',
  'ceo',
  'mafia',
  'musician',
  'office worker',
  'chef',
  'werewolf',
] as const

export const NOVEL_CANONICAL_TAG_ORDER: string[] = Array.from(
  new Set([...NOVEL_CANONICAL_STORY_TAGS, ...NOVEL_CANONICAL_IDENTITY_TAGS])
)

const NOVEL_TAG_INDEX = new Map<string, number>(
  NOVEL_CANONICAL_TAG_ORDER.map((tag, index) => [tag, index])
)

export function sortNovelIdeaTags(tags: string[]): string[] {
  return [...new Set(tags.map((tag) => tag.trim()).filter(Boolean))].sort((left, right) => {
    const leftIndex = NOVEL_TAG_INDEX.get(left)
    const rightIndex = NOVEL_TAG_INDEX.get(right)

    if (leftIndex !== undefined && rightIndex !== undefined) {
      return leftIndex - rightIndex
    }
    if (leftIndex !== undefined) {
      return -1
    }
    if (rightIndex !== undefined) {
      return 1
    }
    return left.localeCompare(right)
  })
}
